import { Children } from 'react'

import './btn-grid.styl'

function BtnGrid({ children }) {
  const arrayChildren = Children.toArray(children)

  return (
    <div className="btn-grid">
      { Children.map(arrayChildren, (child) => {
        return (
          <div className="btn-grid__item">
            {child}
          </div>
        )
      })}
    </div>
  )
}

export default BtnGrid
